import React, { FC, ReactNode } from 'react'

export const IntentHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/3ed10c8fc46d5019f0be7ba8276f4880_IS24_SellYourHouse_highlighter.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/8e2d3394d670d56b3fc48bea467f5b5c_IS24_SellYourHouse_highlighter@2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/6f3563e698399ea07421df2696c438d4_IS24_SellYourHouse_highlighter@3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/3ed10c8fc46d5019f0be7ba8276f4880_IS24_SellYourHouse_highlighter.png'
        }
        width={76}
        height={92}
        alt={''}
      />
    </div>
  )
}
